<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <PowerDropsCheckout :combos="combos"/>
  </b-container>
</template>
<style>

</style>

<script>
// @ is an alias to /src
import PowerDropsCheckout from "@/components/checkout/powerdrops/PowerDropsCheckout.vue";

export default {
  title: 'Next Level Power Drops Checkout',
  name: "PowerDrops",
  props: ["combos"],
  components: {
    PowerDropsCheckout
  }
};
</script>
